import { ExistingSalaryComponents } from 'components/Fnf/types';
import { gql } from 'graphql-request';
import { FnfUpdateResponseSchemaContract } from 'schemas/FnfUpdateResponseSchema';
import { GetFnfResponseSchemaContract } from 'schemas/GetFnfResponseSchema';
import { graphQLApi } from 'utils/Api';
import { PayrollUpdateFnfDataV2Response, PayrollUpdateFnfDataVariables } from '../types';
import { transformToGraphQLVariables } from './updateFnfDetails';

const updateFnfMutation = gql`
  mutation PayrollUpdateFnfDataV2(
    $deactivateDate: String!
    $additions: [ComponentAssignmentRequestInput!]!
    $deductions: [ComponentAssignmentRequestInput!]!
    $lopData: LopDaysUpdateInput!
    $userData: PayrollUserUpdateInput!
    $fnfConfig: PayrollFnfConfigInput
    $deletedDeductionIds: [String!]
    $deletedAdditionIds: [String!]
  ) {
    payrollUpdateFnfDataV2(
      deactivateDate: $deactivateDate
      additions: $additions
      deductions: $deductions
      lopData: $lopData
      userData: $userData
      fnfConfig: $fnfConfig
      deletedDeductionIds: $deletedDeductionIds
      deletedAdditionIds: $deletedAdditionIds
    ) {
      code
      success
      message
      data {
        success
        payslip_link
        payroll_month
        runpayroll_link
        message_type
      }
    }
  }
`;

export const updateFnfDetailsV2 = async (
  fnfData: GetFnfResponseSchemaContract,
  dismissalDate: Date,
  peopleId: string,
  existingComponents: ExistingSalaryComponents,
  isM3S1Disabled: boolean = false,
): Promise<FnfUpdateResponseSchemaContract> => {
  try {
    const queryVariables = transformToGraphQLVariables(
      fnfData,
      dismissalDate,
      peopleId,
      existingComponents,
      isM3S1Disabled,
    );

    const response = await graphQLApi<
      PayrollUpdateFnfDataV2Response,
      PayrollUpdateFnfDataVariables
    >({
      query: updateFnfMutation,
      queryVariables,
    });

    return response.payrollUpdateFnfDataV2.data;
  } catch (error: unknown) {
    throw error;
  }
};
